module.exports = "/static-assets/_next/static/images/strong-arm-emoji-flexing-1-d2573240810a507d47137ef32d4a84e3.png";